// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { ITheme } from "@fluentui/react";

import type { ActionControlSemanticColors } from "@1js/acui-common";
import {
  depths,
  getActionControlSemanticColorsWithTheme,
} from "@1js/acui-common";
import { isReducedAnimations } from "@1js/window-util";
import { customTokens, isNextStyleEnabled } from "@1js/acui-theme";

import {
  getRibbonBottomBarStylingConstants,
  ribbonBottomBarZIndex,
} from "../../ribbonStylingConstants";
import type { RibbonMode } from "../Ribbon/Ribbon.Props";
import { getRibbonHeightTransition } from "./RibbonBottomBar.classNames";
/**
 * The styles for the wrapper div of the Ribbon Bottom Bar.
 *
 * Since these styles may be used by Ribbon placeholders that are rendered early in the boot sequence,
 * we don't want dependencies here on fabric utilities like merge-styles.
 */
export const getRibbonBottomBarWrapperStyles = (
  theme: ITheme,
  ribbonMode: RibbonMode
) => {
  const actionControlSemanticColors: ActionControlSemanticColors =
    getActionControlSemanticColorsWithTheme(theme);
  return {
    height: getRibbonBottomBarStylingConstants(ribbonMode).bottomBarHeight,
    backgroundColor: actionControlSemanticColors.defaultBackgroundColor,
    borderBottom: "1px solid #C8C8C8",
    transition: getRibbonHeightTransition(isReducedAnimations()),
    boxShadow: depths.depth4,
    ...getRibbonBottomBarWrapperStylesNext(),
  };
};

export const getRibbonBottomBarWrapperStylesNext = () => {
  return (
    isNextStyleEnabled() && {
      backgroundColor: customTokens.colorNeutralBackground1,
      borderRadius: customTokens.borderRadiusXLarge,
      boxShadow: customTokens.shadow4,
    }
  );
};

export const getPlaceholderBottomBarWrapperStyles = (
  theme: ITheme,
  mode: RibbonMode
) => {
  return {
    ...getRibbonBottomBarWrapperStyles(theme, mode),
    borderBottom: "none",
    // This is needed so we don't have overflow and it needs to be bound to a type (vs string)
    boxSizing: "border-box" as "border-box",
  };
};

export const getRibbonBottomBarWrapperShadowStyles = (
  theme: ITheme,
  mode: RibbonMode
) => {
  return {
    ...getPlaceholderBottomBarWrapperStyles(theme, mode),
    /**
     * The z-index be lower than RibbonTopBar because the box-shadow above leaks above the top of the bottom bar.
     * The TopBar should hide that.
     */
    zIndex: ribbonBottomBarZIndex,
    /**
     * position is defined as specific strings like 'relative' or 'absolute'
     */
    position: "relative" as "relative",
  };
};
